import React, { useEffect, useRef, useState } from "react";
import filter from "../assets/images/filter.png";
import exportPic from "../assets/images/export.png";
import addChapterIcon from "../assets/images/addChapterIcon.png";
import { Link } from "react-router-dom";
import DelteCourse from "../components/courseManagement/DelteCourse";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  courseStatusChanged,
  getCourses,
} from "../features/slices/coursesManagement";
import { toastService } from "../utils/toastify";
import CommonPagination from "../components/CommonPagination";
import ExportToExcel from "../components/ExportToExcel";
import DeleteStatusModal from "../components/courseManagement/DeleteStatusModal";
import PurchaseDetailModal from "../components/courseManagement/viewCourse/PurchaseDetailModal";
import { canPerformAction } from "../utils/denyAccess";
const initalState = {
  deleteModal: false,
  deleteReasonModal: false,
  status: "",
  id: "",
  searchQuery: "",
  data: "",
  purchaseModal: "",
};
const CoursesManagement = () => {
  const [iState, setUpdateState] = useState(initalState);
  const [page, setPage] = useState(1);
  const {
    deleteModal,
    deleteReasonModal,
    id,
    searchQuery,
    status,
    data,
    purchaseModal,
  } = iState;
  const tableRef = useRef(null);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const dispatch = useDispatch();
  const { courses, loading } = useSelector((state) => {
    return state.courses;
  });

  useEffect(() => {
    dispatch(getCourses({ page }));
    window.scrollTo(0, 0);
  }, [page]);

  const handleChangeStatus = (e, id) => {
    const status = e.target.checked ? "ACTIVE" : "INACTIVE";
    dispatch(
      courseStatusChanged({
        id: id,
        status: status,
      })
    ).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getCourses()).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  // const handleDelete = () => {
  //   dispatch(courseStatusChanged({ id, status: "DELETED" })).then((res) => {
  //     if (res?.payload?.code == 200) {
  //       toastService.success("Course deleted successfully");
  //       dispatch(getCourses());
  //       setUpdateState({ ...initalState });
  //     }
  //   });
  // };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleFilter = (e) => {
    const status = e.target.value;
    setUpdateState((prev) => ({
      ...prev,
      status: status,
    }));
    dispatch(
      getCourses({
        status: status,
        search: searchQuery?.trim(),
      })
    );
  };
  const handleReset = () => {
    setUpdateState(initalState);
    dispatch(getCourses({ page }));
  };
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getCourses({ search: searchQuery?.trim(), status: status })
        ).then((res) => {
          if (res?.payload?.code == 200) {
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="FilterArea">
            <div className="TitleBox m-0">
              <label>&nbsp;</label>
              {canPerformAction("Courses") && (
                <Link to="courseAdd" className="TitleLink">
                  <i className="fa-solid fa-plus" />
                  Add New Course
                </Link>
              )}
            </div>
          </div>
          <div className="Small-Wrapper">
            <div className="NewFilter">
              <div className="SearchBox">
                <input
                  type="search"
                  className="SearchInput"
                  placeholder="Search here by ID, Name, or Others"
                  name="searchQuery"
                  value={searchQuery}
                  onChange={(e) => handleSearch(e)}
                />
                <span>
                  <i className="fa fa-search" />
                </span>
              </div>
              <div className="Actions">
                <div
                  className="form-group"
                  style={{
                    textAlign: "center",
                  }}
                >
                  {/* <label
                    style={{
                      fontWeight: "bolder",
                      fontWeight: "bolder",
                      display: " block",
                      whiteSpace: "nowrap",
                      margin: "4px 20px",
                    }}
                  >
                    Filter by Status
                  </label> */}
                  <select
                    className="form-control FilterStatus"
                    name="status"
                    value={status}
                    onChange={(e) => handleFilter(e)}
                  >
                    <option value="" hidden>
                      Filter by Status
                    </option>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>
                <button className="Button Cancel" onClick={handleReset}>
                  <i className="fa fa-refresh" />
                </button>
                <ExportToExcel
                  ref={tableRef}
                  fileName="courses"
                  type="course"
                />
              </div>
            </div>
            <div className="TableList">
              <table
                className="table-hover"
                ref={tableRef}
                style={{ width: "160%" }}
              >
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Course Id</th>
                    <th>Course Title</th>
                    <th>
                      Teacher/Expert <br /> Name
                    </th>
                    <th>Category &amp; Topic</th>
                    <th>Course Type</th>
                    <th>
                      Total <br /> Enrollments
                    </th>
                    <th>
                      Total No. of Course <br /> Completion
                    </th>
                    <th>
                      Avg. &amp; No. of <br /> Ratings
                    </th>
                    <th>Q&amp;A</th>
                    <th>Status</th>
                    {canPerformAction("Courses") && <th>Add Chapter</th>}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {courses?.result?.[0]?.paginationData.map((res, i) => {
                    return (
                      <tr key={res?._id}>
                        <td>{i + 1 + (page - 1) * 10}</td>
                        <td>
                          <div className="fw500">{res?.course_number}</div>
                        </td>
                        <td>
                          <div className="fw500">{res?.title}</div>
                        </td>
                        <td>
                          <div className="fw500">{res?.teacherName}</div>
                        </td>
                        <td>
                          {res?.categoryData?.[0]?.categoryName} &{" "}
                          {res?.topicData?.[0]?.topicName}
                        </td>

                        <td>
                          {" "}
                          <div className="fw500">
                            {res?.courseType === "PAID" ? (
                              <a
                                className="LinkDirect ml-0"
                                onClick={() => {
                                  setUpdateState((prev) => ({
                                    ...prev,
                                    purchaseModal: true,
                                    data: res,
                                  }));
                                }}
                              >
                                {res?.courseType}
                              </a>
                            ) : (
                              res?.courseType
                            )}
                          </div>
                        </td>
                        <td>
                          {" "}
                          <div className="fw500">{res?.enroledUsers}</div>
                        </td>
                        <td>{res?.completionCount}</td>
                        <td>
                          <Link
                            to={"courseRating"}
                            className="LinkDirect"
                            state={res?._id}
                          >
                            {Math.round(res?.averageRating)}
                            {`(${res?.ratingCount})`}
                          </Link>
                        </td>
                        <td className="d-flex align-items-center">
                          <Link
                            to="courseDetails"
                            className="LinkDirect"
                            state={{ id: res?._id, type: "QA" }}
                          >
                            {res?.qaCounts}
                          </Link>
                          <span
                            className={res?.is_new_qa ? "answeredQues " : ""}
                          ></span>
                        </td>
                        <td
                          style={{
                            cursor: res?.deleteReason ? "pointer" : "auto",
                          }}
                          onClick={() => {
                            res?.deleteReason &&
                              setUpdateState((prev) => ({
                                ...prev,
                                deleteReasonModal: true,
                                data: res,
                              }));
                          }}
                        >
                          <span
                            className={
                              res?.status == "ACTIVE" ? "Green" : "Red"
                            }
                          >
                            {res?.status == "ACTIVE"
                              ? "Available"
                              : res?.status == "INACTIVE"
                              ? "Unavailable"
                              : "Remove"}
                          </span>
                        </td>
                        {canPerformAction("Courses") && (
                          <td>
                            <Link to={"/courses/courseContent"} state={res}>
                              <img
                                src={addChapterIcon}
                                alt=""
                                style={{
                                  width: "30px",
                                  height: "25px",
                                }}
                              />
                            </Link>
                          </td>
                        )}

                        <td>
                          <div className="Actions">
                            {res?.status != "DELETED" &&
                              canPerformAction("Courses") && (
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    name="status"
                                    checked={res?.status == "ACTIVE"}
                                    onChange={(e) =>
                                      handleChangeStatus(e, res?._id)
                                    }
                                  />
                                  <span className="slider" />
                                </label>
                              )}
                            <Link
                              to={"courseDetails"}
                              className="Eyes"
                              state={{ id: res?._id }}
                            >
                              <i className="fa-regular fa-eye" />
                            </Link>
                            {res?.status != "DELETED" &&
                              canPerformAction("Courses") && (
                                <Link
                                  to="courseEdit"
                                  className="Edit"
                                  state={res}
                                >
                                  <i className="fa-regular fa-pen-to-square" />
                                </Link>
                              )}
                            {res?.status != "DELETED" &&
                            canPerformAction("Courses") ? (
                              <a
                                className="Delete"
                                onClick={() => {
                                  setUpdateState((prev) => ({
                                    ...prev,
                                    deleteModal: true,
                                    id: res?._id,
                                  }));
                                }}
                              >
                                <i className="fa-regular fa-trash-can" />
                              </a>
                            ) : (
                              <a
                                style={{
                                  width: "30px",
                                  height: "30px",
                                }}
                              ></a>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="Pagination">
              {courses?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <>
                  <p>
                    Showing {(page - 1) * 10 + 1} to{" "}
                    {courses?.result?.[0]?.paginationData?.length +
                      (page - 1) * 10}{" "}
                    of {courses?.result?.[0]?.totalCount?.[0]?.count} results
                  </p>
                  <div className="PaginationRight">
                    <CommonPagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        courses?.result?.[0]?.totalCount?.[0]?.count || 0
                      }
                      pageRangeDisplayed={4}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {deleteModal && <DelteCourse setUpdateState={setUpdateState} id={id} />}
      {deleteReasonModal && (
        <DeleteStatusModal setUpdateState={setUpdateState} data={data} />
      )}
      {purchaseModal && (
        <PurchaseDetailModal setUpdateState={setUpdateState} data={data} />
      )}
    </>
  );
};

export default CoursesManagement;
